<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Ernsh/tc-custom/9781468315288.jpg?1705201661735" alt="This image is the cover for the book Day of the Lie, Father Anselm Thrillers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Day of the Lie, Father Anselm Thrillers
      </h1>
      <p class="bookDescription body article font2">
        <b>The sleuthing monk travels to Poland to investigate a decades-old betrayal in this “dense, complex [and] fascinating” mystery (<i>Publishers Weekly</i>).</b><br/><br/>Anselm Duffy was a brilliant criminal lawyer before he became a monk who probes the intersection of murderous deeds and moral questions. In <i>The Day of the Lie</i>, Father Anselm receives a visit from an old friend who needs his help with a deadly mystery—one that reaches back to Warsaw during the icy grip of the Cold War.<br/><br/>As a young woman, Roza Mojeska was part of an underground resistance group in Communist Poland. Betrayed by someone close to her—someone still unknown—she was sent to a government prison and forced to make a terrible choice that haunts her to this day. Now, Father Anselm peels back decades of secrets and lies to expose a truth that both victim and torturer would keep hidden. A perceptive examination of guilt and redemption, <i>The Day of the Lie</i> is a gripping, intricate mystery.<br/><br/><b>“Reminiscent of the early works of John le Carré . . . blending sharp suspense and literary resonance.” —Jeffrey Deaver</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        William Brodrick
      </h2>
      
      <p class="authorDescription body article">William Brodrick was an Augustinian friar before leaving the order to become a lawyer and novelist. Winner of the Crime Writers’ Association Gold Dagger Award, he is the author of six novels featuring Father Anselm.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The Overlook Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b08af944